import i18n from 'i18next';

export default ({ params }) => {
  const isInLiveMode = params.type === 'live';

  return [{
    label: i18n.t('draft-status'),
    key: 'draft_state',
    allow_multiple_selects: true,
    options: [{
      id: 1,
      value: 'editing',
      label: i18n.t('unlocked'),
    },
    {
      id: 2,
      value: 'in_review',
      label: i18n.t('review'),
    },
    {
      id: 3,
      value: 'approved',
      label: i18n.t('approved'),
    }],
  },
  isInLiveMode && {
    key: 'start_at',
    label: i18n.t('start-date'),
    options: [
      { id: 1, label: i18n.t('today'), value: 0 },
      { id: 2, label: i18n.t('next-7-days'), value: 7 },
      { id: 3, label: i18n.t('next-30-days'), value: 30 },
      { id: 4, label: i18n.t('next-90-days'), value: 90 },
    ],
  },
  {
    label: i18n.t('owner'),
    key: 'owner',
    allow_multiple_selects: false,
    options: [{
      id: 1,
      value: true,
      label: i18n.t('owned-by-me'),
    },
    {
      id: 2,
      value: false,
      label: i18n.t('not-owned-by-me'),
    }],
  },
  {
    label: i18n.t('last-modified'),
    key: 'last_modified',
    isButton: true,
    allow_multiple_selects: false,
    options: [{
      id: 1,
      value: 0,
      label: i18n.t('today'),
    },
    {
      id: 2,
      value: 1,
      label: i18n.t('yesterday'),
    },
    {
      id: 3,
      value: 7,
      label: i18n.t('last-7-days'),
    },
    {
      id: 4,
      value: 30,
      label: i18n.t('last-30-days'),
    },
    {
      id: 5,
      value: 90,
      label: i18n.t('last-90-days'),
    }],
  },
  !isInLiveMode && {
    isToggle: true,
    key: 'unpublished_changes',
    label: i18n.t('unpublished-changes'),
  }].filter(Boolean);
};
